<template>
  <div class="content">
    <!--<van-nav-bar-->
      <!--title="支付"-->
    <!--&gt;</van-nav-bar>-->
    <div class="swiper-main">
      <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="handleSwiperClick(item)">
          <!--<img :src="image.imgUrl" alt="">-->
          <div class="swiper-box">
            <van-image
                fit="cover"
                lazy-load
                :src="item.imgUrl">
            </van-image>
            <div class="swiper-combo flex-ccs">
              <div v-for="(card, idx) in packages" :key="idx" :class="[item.type]" v-if="packages && packages.length > 0">
                充{{card.priceStr}} <span class="donationStr" v-if="card.donationStr > 0">送 {{card.donationStr}}</span>
                <span v-if="card.discount < 100" > 享{{card.discount / 10}}折</span>
              </div>
            </div>
            <!--<img :src="item.imgUrl" class="slide-image" mode="aspectFill"  @click="goRouter(item)"  alt=""/>-->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="pay-main">
      <!--<div class="flex-rbc pay-money">-->
        <!--<div>金额</div>-->
        <!--<input type="text" v-model="totalMoney" placeholder="请输入支付金额" />-->
      <!--</div>-->
      <div class="storeName flex-rcc">
        {{storeName}}
      </div>
      <div class="pay-money flex-ccc">
        <div class="text">金额</div>
        <div class="money-icon">¥</div>
        <input class="pay-money-input" disabled v-model="val" placeholder="请输入支付金额" />
      </div>
      <div class="keyBoard-box">
        <keyBoard @typing="typing"></keyBoard>
      </div>
      <div class="flex-rbc btn-box">
        <div class="btn-default flex-ccc" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" @click.stop="offerPayApi('vip')">
          <div>会员卡支付</div>
          <div class="fs-12" v-if="tip">({{tip}})</div>
        </div>
        <div class="btn-default flex-ccc" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'"  @click.stop="offerPayApi('pay')">支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { NumberKeyboard } from "vant"
import WXPay from '../../util/wxpay'
import keyBoard from '@/components/common/keyBoard'
import clone from '../../util/clone'
// import login from '../../util/login'
// import msSwiper from "@/components/common/Swiper";
export default {
  name: 'pay',
  data() {
    return {
      bannerList: [],
      show: true, // 键盘显示
      source: '2',
      tip: '',
      loading: false,
      orderNo: '',
      val: '', // 支付金额
      query: '',
      storeName: '',
      packages: []
    };
  },
  computed: {
    ...mapState(['isApp', 'openId', 'jsCode', 'storeIdStr', 'brandIdStr', 'userToken', 'linkNO', 'amount' ])
    // packagesW () {
    //   let arr = this.packages.filter(item => {
    //     return item.discount < 100
    //   })
    //   return arr.length > 0 ? 'packagesW' : ''
    // }
  },
  mounted () {
    console.log('url---pay')
    this.loginFn()
    // this.getPayTip()
    // this.storeIndex()
    setTimeout(() => {
      this.AndroisIos()
    }, 1500)
    this.val = clone(this.amount)
    console.log('pay--- this.amount1111',  this.amount)
    console.log('pay--- this.linkNO',  this.linkNO)
  },
  components: {
    [NumberKeyboard.name]: NumberKeyboard,
    keyBoard
  },
  methods: {
    AndroisIos () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      if (isAndroid) {
        this.loginFn()
      }
    },
    loginFn () {
      this.loginCheck(() => {
        console.log('loginCheck')
        this.getPayTip()
        this.storeIndex()
      })
    },
    loginCheck (callback) {
      if (this.userToken) {
        callback && callback()
      } else {
        console.log('$eventHub---authDone')
        this.$eventHub.$on('authDone', () => {
          // 登陆后执行，不管成功失败
          callback && callback()
        })
      }
    },
    storeIndex () {
      this.$api.userInfo.storeIndex({
      }).then(res => {
        if (res.errCode === '0') {
          const {storeInfo = {}} = res.data
          this.storeName = storeInfo.name
          this.$store.commit('storeInfo', storeInfo)
          console.log('res---storeIndex', res.data)
        } else {
          this.$toast(res.errMsg)
        }
      })
    },
    handleSwiperClick(image) {
      console.log('image', image)
      const { type } = image
      if (type === 'openCard') {
        this.$router.push({ path: '/openCard' })
      } else if (type === 'recharge') {
        this.$router.push({ path: '/rechargeCard' })
      }
    },
    getPayTip () {
      this.$api.userInfo.payTip({
      }).then(res => {
        if (res.errCode === '0') {
          const {tip = '', banners = [], packages = []} = res.data
          this.tip = tip
          this.bannerList = banners
          this.packages = packages
          console.log('banners', this.bannerList)
        } else {
          this.$toast(res.errMsg)
        }
      })
    },
    offerPayApi (str) {
      if (!this.val || this.val <= 0) return this.$toast('请输入支付金额！')
      const {val = '', loading, linkNO} = this
      if (loading) return
      this.loading = true
      let payChancel
      if (this.isApp === 'isAlipay') {
        payChancel = 2
      } else if (this.isApp === 'isWeixin') {
        payChancel = 1
      }
      this.$api.pay.offerPayApi({
        amount: val * 100,
        linkOrderNo: linkNO,
        payChancel
      }).then(res => {
        if (res.errCode === '0') {
          let cardIds = []
          let couponIds = []
          const { orderNo = '', usableCards = [], usableCoupons = [], giftCoupon = [], phone = '' } = res.data
          this.$store.commit('giftCoupon', giftCoupon)
          usableCards.forEach(card => {
            if (card.select) {
              cardIds.push(card.cardId)
            }
          })
          const { DISCOUNT_COUPON = [], CASH_COUPON = [], SKU_COUPON = [] } = usableCoupons
          let couponArr = [...DISCOUNT_COUPON, ...CASH_COUPON, ...SKU_COUPON]
          couponArr.forEach(coupon => {
            if (coupon.select) {
              couponIds.push(coupon.couponId)
            }
          })
          console.log('couponIds', couponIds)
          this.orderNo = orderNo
          let cashierInfo = {
            cardIds,
            couponIds,
            orderNo,
            phone
          }
          /*
           * 会员支付 支付宝/ 微信
           *  通过openId 判断用户是否有会员信息
           *  直接跳收银页面
           * */
          console.log('cashierInfo', cashierInfo)
          if (str === 'vip') { // 会员卡支付
            this.loading = false
            this.$store.commit('orderCashier', cashierInfo)
            this.$router.push({ path: '/commentCashier'})
          } else if (str === 'pay') {
            if (usableCards.length > 0 || couponArr.length > 0) {
              this.loading = false
              this.$store.commit('orderCashier', cashierInfo)
              this.$router.push({ path: '/commentCashier'})
            } else {
              this.payInfo()
            }
          }
        } else {
          this.loading = false
          this.$toast(res.errMsg)
        }
      })
    },
    payInfo () {
      const { orderNo, openId = '' } = this
      let payChancel
      if (this.isApp === 'isAlipay') {
        payChancel = 2
      } else if (this.isApp === 'isWeixin') {
        payChancel = 1
      }
      this.$api.pay.payInfoApi({
        orderNo,
        payChancel,
        openId
      }).then(res => {
        console.log(res);
        if (res.errCode === '0') {
          this.loading = false
          const { payType } = res.data
          console.log('payInfoApi', res.data)
          if (payType === 'wxPay') { // 微信支付
            console.log('isApp', this.isApp)
            if (this.isApp === 'isAlipay') {
              this.aliPay(res.data)
            } else if (this.isApp === 'isWeixin') {
              this.callWXPay(res.data)
            }
          } else if (payType === 'cardPay') {
          } else if (payType === 'couponPay') {}
        } else {
          this.loading = false
          this.$toast(res.errMsg)
        }
      });
    },
    aliPay (obj) {
      ap.tradePay({
        tradeNO: obj.aliTradeNo
      }, (res) => {
        console.log('aliPay', res)
        // ap.alert(res.resultCode);
        if (res.resultCode === '9000') {
          this.paySuccess()
        }
      });
    },
    callWXPay (obj) {
      function payCallback(payResult) {
        // 客户端，支付成功
        if (payResult === 'ok') {
          console.log('支付成功')
          // this.getPrepayOrderStatus();
          this.paySuccess()
          // 客户端，用户取消
        } else if (payResult === 'cancel') {
          console.log('支付失败')
          // do nothing
          // 客户端，其他错误导致支付失败
        } else {
          this.$toast('支付失败，请稍后重试')
        }
      }
      WXPay.callWXPay(obj, payCallback.bind(this))
    },
    del () {
      /* 删除值并不会触发值的校验, 所以需要手动再触发一次 */
      this.val = this.val.slice(0, -1)
    },
    /* 输入 */
    typing (value) {
      /* 如果是点击删除 */
      console.log('typing', value)
      console.log('amount', this.amount)
      console.log('linkNO', this.linkNO)
      if (this.amount && this.amount > 0 && this.linkNO) {
        return this.$toast('支付金额不可修改！')
      }
      if (value === '') {
        this.del()
      }
      console.log('indexOf', this.val.indexOf('.'))
      if (value === '.' && this.val.indexOf('.') > 0) {
        this.val = this.val + value
        console.log('val', this.val)
        this.del()
        return
      }
      /* 获取新的值 */
      this.val = this.val + value
      if (value === '.' && this.val === '.') {
        this.del()
      }
      if (value === '0' && this.val === '0') {
        this.del()
      }
      console.log('lastIndexOf', this.val.lastIndexOf('.'))
      console.log('length', this.val.length)
      if (this.val.length > 4 && this.val.lastIndexOf('.') === this.val.length - 4) {
        this.del()
      }
    },
    paySuccess () {
      const {orderNo} = this
      this.$router.push({ path: '/paySuccess', query: { orderNo } })
    }
  }
};
</script>

<style scoped lang="stylus">
.content
  background #ecedec
  min-height 100vh
  .swiper-main
    .van-swipe-item
      width 100vw
      height 50vw
      .van-image
        width 100vw
        height 50vw
  .swiper-box
    position relative
    width 100vw
    height 50vw
    .swiper-combo
      position absolute
      left 12%
      right 12%
      top 63%
      font-weight 500
      color #feee0c
      z-index 99
      font-size 14px
      line-height 16px
      .openCard
        box-sizing border-box
        background #782410
        padding 2px 6px
        width 100%
        border-radius 22px
        display flex
        flex-direction row
        justify-content center
        align-items center
        margin 0 auto 2px
        &.packagesW
          width 50vw
        .donationStr
          color #fff
      .recharge
        width 100%
        text-align center
        margin-bottom 6px
        .donationStr
          padding 0 6px
          background #d1003e
          color #fff
          border-radius 16px
          margin 0 2px
          font-size 12px
          line-height 16px
    .slide-image
      width 100vw
      height 50vw
.foot-msg
  width 100vw
  height 4vh
  line-height 4vh
  font-size 12px
  text-align center
  color #666
.pay-main
  .storeName
    background #fff
    height 40px
    font-size 20px
    color #111
    margin 5px 0
  .pay-money
    position relative
    height 10vh
    box-sizing border-box
    background #fff
    color #232323
    font-size 16px
    padding 10px 80px
    .text
      position absolute
      top 5px
      left 20px
      font-size 16px
    .money-icon
      position absolute
      top 39px
      left 20px
      font-size 18px
    .pay-money-input
      width 200px
      font-size 28px
      height 40px
      line-height 40px
      color #232323
      text-align center
      background #fff
.keyBoard-box
  margin-top 14px
  height 30vh
.btn-box
  position fixed
  left 0
  right 0
  bottom 0
  padding 10px 20px
  background: #fff
.button-default
    border-radius 0
    width 46%
>>>.van-key--gray
  background #fff
.btn-default
  width 45%
  box-sizing border-box
  height 56px
  text-align center
  font-size 16px
  color #fff
  font-weight bold
  border-radius 6px
</style>
